import { LoadableAfterPaint } from '@confluence/loadable';

export const SiteSettingsHelpPanelLink = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsSiteSettingsHelpPanelLink" */ '../src/Buttons/SiteSettingsHelpPanelLink.tsx'
			)
		).SiteSettingsHelpPanelLink,
});
